import { render } from "./ModalEI.vue?vue&type=template&id=2300b7bc&scoped=true"
import script from "./ModalEI.vue?vue&type=script&lang=js"
export * from "./ModalEI.vue?vue&type=script&lang=js"

import "./ModalEI.vue?vue&type=style&index=0&id=2300b7bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2300b7bc"]])

export default __exports__